// Editable site content, swap any value here to update the site copy.
const A = "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts";

export const PROFILE = {
  name: "Justin Leusner",
  firstName: "Justin",
  lastName: "Leusner",
  role: "Sports Creator & Storyteller",
  tagline: "Turning games into stories you can't scroll past.",
  location: "United States",
  email: "rob@leusner.co",
  youtube: "https://www.youtube.com/@JustinLeusner/videos",
};

export const HERO_LINES = ["MAKING", "SPORTS", "FUN AGAIN"];

export const STATS = [
  { value: "1.5B+", label: "Views & Counting", color: "yellow" },
  { value: "1.2M+", label: "Followers", color: "obsidian" },
  { value: "250K+", label: "Subscribers", color: "coral" },
  { value: "30/30", label: "NBA Arenas Visited", color: "white" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Story First, Always",
    body: "Stats are cool. Stories are unforgettable. Every video starts with a moment that makes you go wait, what?!",
  },
  {
    n: "02",
    title: "Big Swings Only",
    body: "Trading a paperclip into a World Cup final ticket. 30 NBA games in 30 days. If it sounds impossible, that's the idea.",
  },
  {
    n: "03",
    title: "Bring the Whole Crew",
    body: "The best partnerships don't feel like ads, they feel like the whole internet is in on the joke together.",
  },
  {
    n: "04",
    title: "Do Good, Loudly",
    body: "From arena tours to Make-A-Wish, the biggest wins are the ones that happen way off the scoreboard.",
  },
];

export const BRANDS = [
  "NBA", "MLB", "FOX SPORTS", "GATORADE", "FANATICS",
  "DISNEY+", "CHASE", "TICKPICK", "VEEFRIENDS", "UNITED", "MAKE-A-WISH",
];

// Real partner logos provided by the client (rendered as images on light chips).
export const LOGOS = [
  { name: "NBA", src: `${A}/8ig8y5lp_National_Basketball_Association_logo.svg.webp`, link: "https://www.instagram.com/p/DVScXXokbx9/" },
  { name: "NBA 2K", src: `${A}/rihdxcim_NBA-2K-Logo.webp`, link: "https://www.tiktok.com/@justinleusner/video/7471285919841144110" },
  { name: "MLB", src: `${A}/5ww4cu4q_Major_League_Baseball_logo-1.svg.png`, link: "https://www.youtube.com/shorts/2fK7_JF6f6k" },
  { name: "Gatorade", src: `${A}/kewtcw5v_-gatorade.png`, link: "https://www.linkedin.com/posts/justinleusner_yes-we-did-that-22-million-branded-impressions-activity-7213574970243719168-8w7i/" },
  { name: "Disney+", src: `${A}/6barlaa6_Disney%2B_logo.svg.png`, link: "https://www.linkedin.com/posts/justinleusner_i-am-somehow-back-as-the-face-of-disney-activity-7368642434844626948-5opy/", scale: 1.6 },
  { name: "United Airlines", src: `${A}/i3uqr8b6_United-Airlines-Logo-2019-present-1.webp`, link: "https://youtu.be/_AVyKfH_HFA?si=3GUK9233bIfgewdk", scale: 1.5 },
  { name: "TickPick", src: `${A}/rjm4b42x_Tickpick_Logo.webp`, link: "https://www.instagram.com/p/DbBWx1mQcyn/" },
  { name: "YouTube", src: `${A}/holj0k53_YouTube_Logo_2017-1.svg.png`, link: "https://blog.youtube/creator-and-artist-stories/nba-arenas-30-days-make-a-wish/" },
  { name: "Saily", src: `${A}/pzy3q78g_Saily-logo-770x422-1.png`, link: "https://youtu.be/yqbhroqIi_I?si=KxG1tu1ODVNxC_hW" },
  { name: "Fanatics", src: `${A}/vm2cm6ws_1.webp`, link: "https://www.instagram.com/p/Da-3ssTP5nP/" },
  { name: "VeeFriends", src: `${A}/dqcz862t_VeeFriends-Logo.png.webp`, link: "https://www.instagram.com/p/Da8fhVosHxU/" },
  { name: "Chase", src: `${A}/wfpvqz3m_Chase-logo.jpg`, link: "https://youtu.be/PMOuW62AMlE?si=ZBm6Ngcv9DB80pci", scale: 1.5 },
  { name: "Fox Sports", src: `${A}/x9t5x0e0_FOX_Sports_logo.svg.png`, link: "https://www.instagram.com/p/Dae523_JEeC/", scale: 1.5 },
  { name: "SMACKIN'", src: `${A}/kra8jqrw_fcc25b95-dbfc-431f-95a3-e5dfb7f33e59.webp`, link: "https://www.tiktok.com/@justinleusner/video/7535230253824888119" },
  { name: "Event Tickets Center", src: `${A}/eyddo11y_New%2BLogo%2BUpdated%2BColor.png`, link: "https://www.youtube.com/shorts/hLn7285s9yY" },
  { name: "Make-A-Wish", src: `${A}/s24vnwj4_Make-A-Wish-Logo.webp`, link: "https://www.30arenas.org" },
];

export const PARTNERSHIP_OFFERS = [
  { title: "Branded Videos", body: "Big-idea videos that weave your brand into moments people actually want to watch (and share)." },
  { title: "Social Campaigns", body: "Multi-platform mayhem across YouTube, Instagram and TikTok built for reach and rewatches." },
  { title: "Live & Experiential", body: "Arena takeovers, event stunts and on-the-ground content that turns access into hype." },
  { title: "Custom Collabs", body: "Got a wild idea? Let's cook something nobody's ever seen before." },
];

export const SOCIALS = [
  { name: "YouTube", handle: "@JustinLeusner", url: "https://www.youtube.com/@JustinLeusner/videos", icon: "SiYoutube" },
  { name: "Instagram", handle: "@justinleusner", url: "https://www.instagram.com/justinleusner/", icon: "SiInstagram" },
  { name: "TikTok", handle: "@justinleusner", url: "https://www.tiktok.com/@justinleusner", icon: "SiTiktok" },
  { name: "LinkedIn", handle: "in/justinleusner", url: "https://www.linkedin.com/in/justinleusner", icon: "SiLinkedin" },
];

export const IMAGES = {
  face: "/justin-face.png?v=2",
  heroCutout: "/justin-cutout.png",
  justinRob: "/justin-rob.png",
  hero: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  portrait: "https://images.unsplash.com/photo-1587296101198-67dcc4fe72f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const VALUES = [
  { label: "LONG-TERM PARTNERS", emoji: "🤝", labelColor: "text-blue", src: `${A}/0lnktyx2_IMG_7502.jpg`, rotate: -3 },
  { label: "TRUST", emoji: "🤩", labelColor: "text-coral", src: `${A}/u2qez3v2_IMG_7507.jpg`, rotate: 2 },
  { label: "CREATIVE IDEAS", emoji: "🤔", labelColor: "text-obsidian", src: `${A}/be6oe3wh_IMG_6967.webp`, rotate: -2 },
  { label: "FUN!", emoji: "🥳", labelColor: "text-blue", src: `${A}/h4jz4okn_IMG_1334.webp`, rotate: 3 },
];

export const THUMBNAILS = [
  { src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/lr768uno_FIFA%20World%20Cup%20Series%20FINAL%20Thumbnails-18.webp", alt: "Paperclip to FIFA World Cup Final ticket" },
  { src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/tx95pv0x_hq720-2.jpg", alt: "Every NBA arena challenge" },
  { src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/rjpprul5_images-12.jpeg", alt: "Press it challenge" },
];

export const ABOUT = {
  overline: "The Story",
  heading: "Hi! I'm Justin! I make sports\u00A0fun!\u00A0🏀",
  caption: "I was cuter back then lol...",
  paragraphs: [
    "Ever since I was 10 years old, I've been making sports YouTube videos every single day.",
    "Over the years that obsession has added up to 1.5 billion+ views, 1.2M+ followers, and a front-row seat to some of the best moments in sports.",
    "In March of 2026 I took the whole thing on the road to visit all 30 NBA arenas and raise $100,000 for Make-A-Wish, a lifelong dream, and part of a long journey to make my content feel purposeful and fun at the same time.",
    "These days my whole job is making YouTube videos every single day, and I still can't believe I get to say that. My goal is simple: keep making that 10-year-old kid's dream come true, and show every other 10-year-old out there that you really can do anything you put your mind to. I couldn't be more grateful.",
  ],
  photos: [
    { src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/e363ez0b_IMG_7510.jpg", alt: "Young Justin with an Eagles jersey on Christmas", rotate: -6 },
    { src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/rum1hi6f_IMG_7511.jpg", alt: "Young Justin at a Phillies game", rotate: 5 },
    { src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/rt4ygaat_IMG_7512.jpg", alt: "Young Justin at a 76ers event", rotate: -3 },
  ],
};

export const TIMELINE = [
  { year: "2013", text: "Started a YouTube channel at 10 years old, it changed my life forever.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/e363ez0b_IMG_7510.jpg" } },
  { year: "2015", text: "Hit 100 subscribers!", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/6rxgaha9_Screenshot%202026-07-29%20at%2012.48.57%E2%80%AFPM.png" } },
  { year: "2016", text: "Found my footing as a Madden Mobile / NBA LIVE Mobile creator, grew to 1,000 subscribers.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/9u10djwn_Screenshot%202026-07-29%20at%2012.47.55%E2%80%AFPM.png" } },
  { year: "2017–2018", text: "Signed to the NBA Playmakers program at 14 years old & hit 30,000 YouTube subscribers.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/hgaddhyd_IMG_7515.jpg" } },
  { year: "2019–2020", text: "A mental health spiral → quit creating → saved by Jesus → got baptized → started a social media agency helping businesses grow on YouTube.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/pfcghsgu_IMG_7517.jpg" } },
  { year: "2021", text: "Graduated high school & grew my agency to $20k/mo.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/yzpiigcm_IMG_7516.jpg" } },
  { year: "2022", text: "Founded TDAY Sports (Gen-Z's ESPN), a short-form sports social media company that surpassed 1 billion all-time short-form views.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/ddyhbu53_1740491173417.jpeg" } },
  { year: "2023–2024", text: "Crossed 100,000 subscribers. Partnerships with Gatorade, SMACKIN' Seeds & Fabletics, 4 acquisition offers, then graduated from Penn State in December.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/vnipvjlv_1736257336242.jpeg" } },
  { year: "2025", text: "Gave a TED Talk, then pivoted to go all-in on my personal brand.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/21u80ia0_1742174446513.jpeg" } },
  { year: "Mar 2026", text: "Broke the World Record for fastest time to visit all 30 NBA arenas, raised $101,000 for Make-A-Wish.", medias: ["https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/tx95pv0x_hq720-2.jpg", "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/cpzej47e_1774899774520-1.jpeg"] },
  { year: "Jun 2026", text: "Got married to my beautiful wife Kenzie! 🥳 (who I met at VidSummit 2022)", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/nk8q7ghp_1782049815700-1.jpeg" } },
  { year: "Jul 2026", text: "Traded a paperclip into a FIFA World Cup Final ticket!", medias: ["https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/lr768uno_FIFA%20World%20Cup%20Series%20FINAL%20Thumbnails-18.webp", "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/y312g9g9_hq720-3.jpg"] },
  { year: "2027", text: "30 MLB stadiums in 30 days Tour.", media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/5ww4cu4q_Major_League_Baseball_logo-1.svg.png" }, note: "currently shopping title sponsors for this series 👀" },
  { year: "The Next 5 Years", text: "Sports videos that combine spectacle + storytelling, to inspire the next generation to take action on their dreams. By 2031 I'll be the most trusted sports creator in the world 🚀", highlight: true, media: { type: "image", src: "https://customer-assets-lqy194kg.emergentagent.net/job_brand-partners-hub/artifacts/38ggs9z2_IMG_4652.png" }, caption: { icon: "youtube", text: "Neal Mohan, CEO, YouTube" } },
];

export const PRESS = [
  {
    outlet: "YouTube Official Blog",
    logo: `${A}/s5gdw0p0_images-1.png`,
    headline: "How a 30-day NBA arena tour set a world record and met a major charity goal",
    excerpt: "Justin Leusner visited all 30 NBA arenas in 30 days to raise $100,000 for Make-A-Wish.",
    date: "May 18, 2026",
    url: "https://blog.youtube/creator-and-artist-stories/nba-arenas-30-days-make-a-wish/",
    image: `${A}/77lbthej_1774899774520-1.jpeg`,
    logoClass: "h-20 md:h-24 w-auto object-contain",
    accent: "coral",
  },
  {
    outlet: "TEDx",
    logo: `${A}/jegtmd3t_TEDx-Logo.webp`,
    headline: "Why Gen Z struggles to find work-life balance",
    excerpt: "Justin's TEDxPSU talk on why Gen Z can't unplug, and how redemptive work reframes the whole conversation.",
    date: "TEDxPSU",
    url: "https://www.youtube.com/watch?v=wmbZS-Ic5sk",
    image: `${A}/4waq9nqk_20181016_072845380_iOS.webp`,
    accent: "coral",
  },
  {
    outlet: "Colin and Samir",
    logo: `${A}/7fsbn4ka_unnamed.jpg`,
    headline: "He posted his first 31 long-form videos. It didn't work.",
    excerpt: "Colin and Samir break down Justin's 30-arenas-in-30-days series, from strategy to storytelling to the payoff.",
    date: "YouTube Feature",
    url: "https://youtu.be/R5hsk05wPeE",
    image: "https://i.ytimg.com/vi/R5hsk05wPeE/maxresdefault.jpg",
    accent: "yellow",
  },
  {
    outlet: "FOX 35 Orlando",
    logo: `${A}/qk8id66s_e9613de088780284ec8c34d3630258ea_fgraphic.png`,
    headline: "30 Days, 30 Arenas: Justin Leusner's NBA Wish Mission",
    excerpt: "Justin joins 'The 407' during his Orlando stop, sharing his whirlwind 30-day journey across all 30 NBA arenas to raise money for the Make-A-Wish Foundation.",
    date: "Live TV Feature",
    url: "https://www.fox35orlando.com/video/fmc-t2sj8ijpt75b0dq3",
    image: "https://static-media.fox.com/fmcv3/prod/fts/g18hmpi1xzpg4l1o/rshfp72hxcnlgr8h.jpg",
    accent: "obsidian",
  },
  {
    outlet: "FOX 29 Philadelphia",
    logo: `${A}/vyiprtqf_images-2.png`,
    headline: "Content Creator trades a paper clip for a World Cup ticket",
    excerpt: "YouTube content creator and host of 'Trading to a Ticket' Justin Leusner shares the story of how he traded a paper clip all the way up to a World Cup final ticket.",
    date: "Live TV Feature",
    url: "https://www.fox29.com/video/fmc-vwev224rqb2rlb5z",
    image: "https://static-media.fox.com/fmcv3/prod/fts/hlmfqltoxdi6mxon/fgpi342xqdbwwy14.jpg",
    accent: "obsidian",
  },
  {
    outlet: "Action News 5 (WMC Memphis)",
    logo: `${A}/tusj3ftd_WMC_Action_News_5_2023.svg.png`,
    headline: "NBA fan raising $100K for Make-A-Wish",
    excerpt: "Justin Leusner is traveling to all 30 NBA arenas trying to raise $100,000 for Make-A-Wish.",
    date: "Mar 18, 2026",
    url: "https://www.actionnews5.com/video/2026/03/18/nba-fan-raising-100k-make-a-wish/",
    image: `${A}/4tc4iys4_https---do0bihdskp9dy.cloudfront.net-03-18-2026-t_339f21645a914740b30252bead342a31_name_file_1280x720_2000_v3_1_.jpg.webp`,
    accent: "coral",
  },
  {
    outlet: "The Portland Tribune",
    logo: `${A}/htn9p64v_images-11.jpeg`,
    headline: "Sports creator visits Portland's Moda Center for '30 Arenas in 30 Days' Make-A-Wish fundraiser",
    excerpt: "Justin's Portland stop, the 27th of 30, and a deep-dive Q&A on why he traded a 'Gen Z's ESPN' brand for redemptive, long-form storytelling.",
    date: "Mar 24, 2026",
    url: "https://portlandtribune.com/2026/03/24/sports-creator-visits-portlands-moda-center-for-30-arenas-in-30-days-make-a-wish-fundraiser/",
    image: "https://portlandtribune.com/wp-content/uploads/sites/20/2026/03/Justin-Leusner-of-Basketball-Today-Official-marked-his-27th-stop-on-his-30-Arenas-in-30-Days-i_bea555.jpg",
    accent: "coral",
  },
  {
    outlet: "Spectrum News 13",
    logo: `${A}/ianyljwh_Spectrum-News-13_logo.jpg`,
    headline: "NBA fan goes to all 30 Arenas in 31 days",
    excerpt: "Spectrum Sports 360 caught up with Justin during halftime at the Kia Center as he chased a Guinness World Record and a $100K Make-A-Wish goal.",
    date: "May 14, 2026",
    url: "https://mynews13.com/fl/orlando/news/2026/05/13/justin-leusner-30-nba-arenas",
    image: `${A}/yjp8morm_30_NBA_Arenas_in_30_Days_00_01_00_19_Still003_crop.jpeg`,
    accent: "obsidian",
  },
  {
    outlet: "San Antonio Express-News",
    logo: `${A}/o4p7zvtz_SanAntonioExpressNews_logo.jpg`,
    headline: "Spurs host YouTuber's Make-A-Wish stop on his 30-arena quest",
    excerpt: "Justin's San Antonio stop at Frost Bank Center, where the Spurs granted 14-year-old Jorge his wish to be a Spur for the day, one of the tour's most emotional moments.",
    date: "Mar 2026",
    url: "https://www.expressnews.com/lifestyle/article/spurs-make-a-wish-30-arenas-21959392.php",
    image: `${A}/qitjbuld_maxresdefault-2.webp`,
    accent: "coral",
  },
];

export const SPEAKING = [
  { name: "TED", key: "ted", logo: `${A}/t054efj3_TED_three_letter_logo.svg.webp`, tileClass: "bg-white" },
  { name: "VidSummit", key: "vidsummit", logo: `${A}/o5ag3irt_images-7.png`, tileClass: "bg-white" },
  { name: "VidCon", key: "vidcon", logo: `${A}/osmmynee_059556290cb62877493cc10b8df08d6cc236453a.webp`, tileClass: "bg-white" },
  { name: "Beyond Now Summit", key: "beyond-now", logo: "/logos/beyondnow.png", tileClass: "bg-white" },
  { name: "UCLA", key: "ucla", logo: `${A}/vpkqjas6_UCLA-Logo.webp`, tileClass: "bg-white" },
  { name: "Penn State", key: "penn-state", logo: `${A}/afp3553s_Penn-State-University-Logo-2015-present.webp`, tileClass: "bg-white" },
  { name: "YouTube Creators", key: "youtube-creators", logo: "/logos/youtubecreators.png", tileClass: "bg-white" },
  { name: "CreatorHub LIVE", key: "creatorhub-live", logo: "/logos/creatorhub.png", tileClass: "bg-white" },
  { name: "Youth Marketing Strategy London", key: "yms-london", logo: "/logos/yms.png", tileClass: "bg-white" },
];
